<template>
    <div class="level is-mobile">
        <div class="level-left">
            <h1 class="title is-5">Team Assignment</h1>
        </div>
        <div class="level-right">
            <div v-if="currentFD.teams_driving && currentFD.status == 'DRAFT'">
                <UpdateTeams :fdID="currentFD.id" :drivingTeams="currentFD.teams_driving"
                    :walkingTeams="currentFD.teams_walking">
                </UpdateTeams>
            </div>
        </div>
    </div>

    <div v-if="currentFD.teams_driving" class="block">
        <p>Driving teams: <b>{{ currentFD.teams_driving }}</b></p>
        <p>Walking teams: <b>{{ currentFD.teams_walking }}</b></p>
    </div>
   
    <div v-else>
        <p>Please input number of Driving and Walking teams to be created.</p>
        <div class="columns is-mobile">
            <div class="column">
                <b>Driving Teams</b>
                <input v-model="drivingTeams" class="input" type="number" />
            </div>
            <div class="column">
                <b>Walking Teams</b>
                <input v-model="walkingTeams" class="input" type="number" />
            </div>
        </div>

        <div v-if="validationErrors.length" class="block notification is-danger is-light">
            <p>
                <b>Please correct the following error(s):</b>
            <ul>
                <li v-for="validationError in validationErrors" :key="validationError">{{ validationError }}</li>
            </ul>
            </p>
        </div>

        <div v-if="!!error" class="notification is-danger">
            <p>{{ error }}</p>
        </div>

        <div class="align-center">
            <button @click="createTeams()" class="button is-rounded is-info"
                :class="[isLoading ? 'is-loading' : '']">Create
                Teams</button>
        </div>
    </div>
</template>

<script>
import UpdateTeams from './UpdateTeams.vue';

export default {
    components: {
        UpdateTeams
    },
    data() {
        return {
            drivingTeams: null,
            walkingTeams: null,
            error: null,
            validationErrors: [],
            isLoading: false
        }
    },
    methods: {
        async createTeams() {
            this.isLoading = true;
            this.validateForm();
            if (this.isFormValid) {
                try {
                    await this.$store.dispatch('fd/updateTeams', {
                        fdID: this.currentFD.id,
                        drivingTeams: this.drivingTeams,
                        walkingTeams: this.walkingTeams
                    });
                } catch (error) {
                    this.error = error.message || "Something went wrong!";
                    console.log(error);
                }
            }
            this.isLoading = false;
        },
        validateForm() {
            this.isFormValid = false;
            this.validationErrors = [];
            if (!this.drivingTeams) {
                this.validationErrors.push("Please input Driving Teams.")
            }
            if (!this.walkingTeams) {
                this.validationErrors.push("Please input Walking Teams.")
            }
            if (!this.validationErrors.length) {
                this.isFormValid = true;
            }
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        }
    }
}
</script>